// hooks.
import { UserRoles } from "@shared/WrapperByUserRole/WrapperByUserRole";
import { useRoleByUser } from "@store/apiSlices/roles/role.hook";
import { formatPrice } from "@utils";
import {
  PriceRange,
  isPriceWithinPercentageRange,
} from "@utils/priceUtils.ts/isPriceWithinPercentageRange";

export const useApplyRangeToPublicationPrice = () => {
  const { userRole } = useRoleByUser();

  const applyRangeToPublicationPrice = ({
    defaultPrice,
    leader,
    price,
  }: {
    defaultPrice: number;
    leader: string;
    price: number;
  }) => {
    const PERCENTAGE_THRESHOLD = 5;
    if (userRole === UserRoles.LEADER || leader) return;

    // Fallar cerrado: si el servicio de referencia falló o no hay precio
    // original válido, no se puede validar el rango. Se bloquea el guardado
    // en lugar de dejar pasar cualquier valor.
    if (!Number.isFinite(defaultPrice) || defaultPrice <= 0) {
      return "No se pudo validar contra el precio de referencia. Recarga la información e intenta de nuevo.";
    }

    // El precio ingresado debe ser un número válido y mayor a 0.
    if (!Number.isFinite(price) || price <= 0) {
      return "Ingresa un precio válido mayor a 0.";
    }

    const defaultPublicationPriceFormatted = formatPrice(defaultPrice);
    const priceInRange = isPriceWithinPercentageRange(
      price,
      defaultPrice,
      PERCENTAGE_THRESHOLD,
    );
    if (priceInRange === PriceRange.UP) {
      return `El precio original (${defaultPublicationPriceFormatted}) no puede superar el ${PERCENTAGE_THRESHOLD}% de incremento`;
    } else if (priceInRange === PriceRange.DOWN) {
      return `El precio original (${defaultPublicationPriceFormatted}) no puede superar el ${PERCENTAGE_THRESHOLD}% de descuento`;
    }
  };

  return { applyRangeToPublicationPrice };
};
